$(function () {
	$('#opportunities-carousel').carousel({
		interval: 0
	});

	$('#opportunities-carousel').on('slid.bs.carousel', function (e) {
		$('#current-slide-number').text(e.to + 1);
	});
});